import React from 'react';
import { Row, Col, Card, Typography } from 'antd';
import { SecurityScanOutlined, ThunderboltOutlined, GlobalOutlined } from '@ant-design/icons';

const { Title } = Typography;

const Features = () => {
  const features = [
    {
      icon: <SecurityScanOutlined style={{ fontSize: '36px' }} />,
      title: '内容丰富',
      description: '我们精心制作了众多类型、不同视角的历史文化内容节目，涵盖多个历史王朝'
    },
    {
      icon: <ThunderboltOutlined style={{ fontSize: '36px' }} />,
      title: '快速更新',
      description: '免费内容几乎每日都会更新；最新的专辑亦保证在固定的周期持续推出'
    },
    {
      icon: <GlobalOutlined style={{ fontSize: '36px' }} />,
      title: '全球支持',
      description: '无论您是否身处海外，APP提供多语言支持，覆盖全球主要市场'
    }
  ];

  return (
    <div style={{ padding: '40px 0', background: '#f5f5f5' }}>
      <Title level={2} style={{ textAlign: 'center', marginBottom: '40px' }}>
        关于产品
      </Title>
      <Row gutter={[24, 24]} justify="center">
        {features.map((feature, index) => (
          <Col xs={24} sm={12} md={8} key={index}>
            <Card style={{ textAlign: 'center' }}>
              {feature.icon}
              <Title level={4}>{feature.title}</Title>
              <p>{feature.description}</p>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Features;